import React from 'react'
import TextInput from '../../../../components/FormElements/TextInput'
import { SelectInput } from '@demandlocal/components'
import states from '../../../../lib/utils/states'
import { IndustryOptions } from '../EditDealership'
import countries from '../../../../lib/utils/countries'
import { useFormContext } from 'react-hook-form'

export default function DealershipInfo(): JSX.Element {
  const { setValue, watch } = useFormContext()
  const country = watch('country')

  return (
    <div className={'pt-8 pb-8 flex flex-col gap-5'}>
      <div>
        <TextInput
          rules={{ required: 'This field is required' }}
          inverted
          placeholder={'Name'}
          name={'dealership'}
          label={'Name'}
        />
      </div>
      <div className={'flex flex-row gap-5'}>
        <div className={'w-1/2'}>
          <TextInput
            inverted
            placeholder={'Address'}
            name={'address'}
            label={'Address'}
          />
        </div>
        <div className={'w-1/2'}>
          <TextInput inverted placeholder={'City'} name={'city'} label={'City'} />
        </div>
      </div>
      <div className="flex flex-row gap-5">
        <div className={'w-1/3'}>
          <SelectInput
            label={'State'}
            placeholder={'Choose state'}
            name={'state'}
            options={states.filter((state) => state.country === country?.value)}
            isMulti={false}
          />
        </div>
        <div className={'w-1/3'}>
          <SelectInput
            label={'Country'}
            placeholder={'Choose country'}
            name={'country'}
            options={countries}
            isMulti={false}
            onChange={() => setValue('state', null)}
          />
        </div>
        <div className={'w-1/3'}>
          <TextInput inverted placeholder={'Zip'} name={'zip'} label={'Zip Code'} />
        </div>
      </div>
      <div className={'grid grid-cols-2 gap-5'}>
        <div>
          <TextInput inverted placeholder={'Email'} name={'email'} label={'Email'} />
        </div>
        <div>
          <TextInput
            inverted
            placeholder={'Contact phone'}
            name={'phone'}
            label={'Contact phone'}
          />
        </div>
      </div>
      <div className={'grid grid-cols-2 gap-5'}>
        <TextInput inverted placeholder={'Website'} name={'url'} label={'Website'} />
        <SelectInput
          label={'Industry'}
          placeholder={'Industry'}
          name={'industry'}
          options={IndustryOptions}
          isMulti={false}
        />
      </div>
    </div>
  )
}
